import { Profile } from './Profile';

export interface UserResponse {
    profile: Profile;
    token: string;
    refreshToken: string;
    refreshTokenExpiryTime: Date;
}

export interface UserWithDetailsDto {
    id: string;
    scriptSureUserId?: number | null;
    lastScriptSureUpdate?: string;
    scriptSureUserType: string;
    scriptSureUserAdminLevelDisplay: string;
    scriptSureUserPermissionDisplay: string;
    firstName?: string | null;
    lastName?: string | null;
    teams: string[];
    isActive: boolean;
    npi?: string | null;
    dea?: string | null;
    stateLicense?: string | null;
    hospiceOrganizationId?: string | null;
}

export interface SimpleUserWithDetails {
    id: string;
    scriptSureUserId?: number | null;
    lastScriptSureUpdate?: string;
    isActive: boolean;
}

export interface ToggleUserStatusRequest {
    activateUser: boolean;
    userId: string;
}

export interface ScriptSureUserWithDetailsDto {
    id: string;
    userType: string;
    adminLevel: ScriptSureUserAdminLevel;
    userPermissionType: ScriptSureUserPermissionType;
    suffix: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    timeZone: string;
    practices: ScriptSurePracticeDto[];
    isActive: boolean;
    npi?: string;
    dea?: string;
    stateLicense?: string;
}

export enum ScriptSureUserPermissionType {
    NA = 0,
    Provider = 1,
    SupportingStaff = 2,
}

export interface ScriptSurePracticeDto {
    id: string;
    name: string;
}

export enum ScriptSureUserAdminLevel {
    NA = 0,
    Basic = 1,
    Full = 2,
}
export interface CreateNewTeamRequestByLocation {
    locationId: string;
    teamName: string;
    rxLogicPracticeID: string;
    scriptSurePracticeID: string;
    teamCode: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phoneNumber: string;
    emailAddress: string;
}
export interface CreateNewTeamRequest {
    payload: CreateNewTeamRequestByLocation;
    location_id: string;
}

export interface CreateNewOrganizationRequest {
    name: string;
    oranizationId: string;
    code: string;
    effectiveDate: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phoneNumber: string;
    emailAddress: string;
}